var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98857 0.5C9.29012 0.5 11.142 2.31109 11.142 4.547V5.69701C12.4338 6.10022 13.375 7.2696 13.375 8.6663V12.369C13.375 14.0981 11.9415 15.5 10.1742 15.5H3.8266C2.05852 15.5 0.625 14.0981 0.625 12.369V8.6663C0.625 7.2696 1.56696 6.10022 2.85796 5.69701V4.547C2.86559 2.31109 4.7175 0.5 6.98857 0.5ZM6.99619 9.03821C6.63038 9.03821 6.33316 9.32888 6.33316 9.68662V11.3412C6.33316 11.7064 6.63038 11.9971 6.99619 11.9971C7.36962 11.9971 7.66684 11.7064 7.66684 11.3412V9.68662C7.66684 9.32888 7.36962 9.03821 6.99619 9.03821ZM7.00381 1.80428C5.45674 1.80428 4.19927 3.02658 4.19165 4.5321V5.53528H9.80835V4.547C9.80835 3.03404 8.55088 1.80428 7.00381 1.80428Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.f901bba78d931db4687e7bb97a8e6b21.svg";
export { ForwardRef as ReactComponent };